import { ValidationResult } from 'src/lib/flow/validation';

export const getErrorMessage = (result: ValidationResult): string | undefined => {
  if (!result.isValid) {
    switch (result.type) {
      case 'required':
        return 'This field is required';
      case 'too_small':
        return `Can't be less than ${result.min}`;
      case 'too_large':
        return `Can't be greater than ${result.max}`;
      case 'min_equal_or_greater_than_max':
        return `Minimum must be less than maximum`;
      case 'email_invalid':
        return `Hm, looks like that wasn’t a valid email`;
      case 'phone_invalid':
        return `Hm, looks like that wasn’t a valid phone number`;
      case 'unknown_value':
        return `Please select a valid option`;
    }
    // should be unreachable
    return undefined;
  }

  return undefined;
};
